/** @format */

import Messages from "./../../library/Messages";
import Attributes from "./Attributes";
import Popups from "./../Popups";
import Personalise from "./Personalise";

export default class Basket {
	constructor() {
		this.instance = self;
		this.activeButton = null;
	}

	clearButtonLoading() {
		if (this.activeButton && this.activeButton.length) {
			this.activeButton.removeClass("is-loading");
			if (this.activeButton.is("button, input, select, textarea")) {
				this.activeButton.prop("disabled", false);
			}
			this.activeButton = null;
		}
	}

	static init() {
		const self = new Basket();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		window.site.updateBasketCount = function (itemId) {
			self.onUpdateBasketCount(itemId);
		};

		window.site.toastSuccess = function (isSuccess) {
			self.toastSuccess(isSuccess);
		};

		$(document).on("click", ".js-team-basket-button", function (e) {
			e.preventDefault();
			console.log('submit');

			if( $('.js-forward-order-toggle').prop('checked')    ){
				$('.js-product-forward-basket-warning').attr('data-basket-forward-order-status' , 'forward-order' );
			}else{
				$('.js-product-forward-basket-warning').attr('data-basket-forward-order-status' , 'normal-order' );
			}

			self.addToBasketMulti($(".js-add-to-basket"), $(this));
		});

		$(document).on("click", ".js-bundle-basket-button", function (e) {
			e.preventDefault();

			const $button = $(this);

			if ($button.hasClass("no-submit")) {
				return false;
			}

			const $form = $button.closest("form.js-add-bundle-to-basket");

			if (!$form.length) {
				return false;
			}

			if (!self.checkAllAttributesSelected($form)) {
				return false;
			}

			self.addBundleToBasket($form, $button);
		});

		$(document).on("submit", ".js-add-bundle-to-basket", function (e) {
			e.preventDefault();
			return false;
		});

		$(document).on("submit", ".js-add-items-to-backorder", function (e) {
			e.preventDefault();

			self.addItemsToBackOrder($(this).serializeArray());
		});

		$(document).on("submit", ".js-add-wishlist-to-basket", function (e) {
			e.preventDefault();

			self.addWishlistToBasket($(this));
		});

		$(document).on("click", ".js-remove-basket-item", function (e) {
			e.preventDefault();

			self.removeItem($(this).data("id"));
		});

		$(document).on("click", ".js-remove-basket-bundle-item", function (e) {
			e.preventDefault();

			self.removeBundleItem($(this).data("instance"));
		});

		$(document).on("click", ".js-decrease-basket-quantity", function (e) {
			e.preventDefault();

			const $this = $(this),
				$input = $this.next(".basket-item-quantity"),
				val = $input.val();

			if (val > 1) {
				$input.val(val - 1);
				$input.trigger("change");
			}
		});

		$(document).on("click", ".js-increase-basket-quantity", function (e) {
			e.preventDefault();

			const $this = $(this),
				$input = $this.prev(".basket-item-quantity"),
				val = $input.val();

			$input.val(parseInt(val) + 1);
			$input.trigger("change");
		});

		$(document).on("change", ".js-on-change-update-quantity", function () {
			let $this = $(this);

			let basketItem = $this.parents(".basket-item");

			let minQty = parseInt(basketItem.data("forward-min-qty"));

			// Add up all quantities for this basket item
			let totalQty = 0;
			basketItem.find(".basket-item-quantity").each(function () {
				let qty = parseInt($(this).val());
				if (!isNaN(qty)) {
					totalQty += qty;
				}
			});

			// If total quantity is less than minimum, allow update request of basket item
			if (totalQty >= minQty) {

				if ($this.val() > 0) {
					self.updateItemQuantity($this.parents("form"));
				} else {
					$this.val(1);
					self.updateItemQuantity($this.parents("form"));
				}

				// Enable checkout button
				$(".js-basket-checkout-btn")
					.removeClass("mod-disabled")
					.attr("aria-disabled", "false");
			} else {

				self.updateItemQuantity($this.parents("form"));

				// Disabled checkout button
				$(".js-basket-checkout-btn").addClass("mod-disabled").attr("aria-disabled", "true");

				if ($this.val() == 0) {
					$this.val(1);
				}
			}
		});

		$(document).on("click", ".js-submit-out-of-stock-form", function (e) {
			e.preventDefault();

			self.setBackOrderRefInput();

			// Submit the form
			$(".js-popup-items-out-of-stock form").submit();
		});

		// Event for removing error classes when submit tried when required fields are invalid
		$(document).on("change", ".js-add-to-basket .js-select2", function (e) {
			$(this).next(".select2-container").removeClass("is-erroneous");
		});

		$(document).ready(function() {
			if( $('.js-product-forward-basket-warning').attr('data-basket-forward-order-status') == 'forward-order' ){
				$('.js-forward-order-toggle').click();
			}
		});

		$(document).on("click", ".js-basket-checkout-btn", function (e) {
			const $this = $(this);
			if (!$this.hasClass("mod-disabled")) {
				//$this.find(".btn-text").hide();
				$this.find(".btn-spinner").show();
				$this.css("pointer-events", "none");
				// disable button
				$this.attr("disabled", "disabled");
			}
		});

	}

	onUpdateBasketCount(itemId ) {

		const self = this;
		let prodid = itemId
		oc.ajax("shopBasket::onUpdateBasketCount", {
			data: { product_id: prodid},
			update: {
				"banner/delivery-banner": ".js-delivery-banner",
			},
			success: function (data, responseCode, xhr) {
				$(".amount-in-basket").text(data.basket_count_for_product || 0);
				let uniquevalue = 0;
				let quantityfinder = $(".minimum-quantity");
				if (quantityfinder.length > 0) {
					if( (data.basket_count_for_product || 0) == 0 ){
						$('.quantity-avilable').show();
						$('.product-quantity-discount-info'	).hide();
						$('.maximum-quantity-discounts').hide();

					}else{
						$('.quantity-avilable').hide();
						$('.product-quantity-discount-info'	).show();

					}
					quantityfinder.each(function () {
						if( parseInt($(this).text()) > parseInt(data.basket_count_for_product || 0) && uniquevalue == 0 ){

							let discountAmounts = parseInt($(this).text() ) - parseInt(data.basket_count_for_product || 0);
							$('.buy-more').text( discountAmounts ) ;
							$('.discount-amount').text( $(this).siblings('.discount-percentage').text() ) ;
							uniquevalue = 1;

							return false;

						}else if(  parseInt(data.basket_count_for_product || 0) >= quantityfinder.last().text()  ){
							$('.maximum-quantity-discounts').show();
							$('.product-quantity-discount-info'	).hide();
						}

					});
				}

				var basketCount = 0;
				if ($(".js-basket-count").attr("data-count") == undefined) {
					basketCount = 0;
				} else {
					basketCount = parseInt($(".js-basket-count").attr("data-count"));
				}

				if( basketCount == 0 ){
					$('.js-team-basket-button').removeClass("d-none");
					$(".js-product-forward-basket-warning").addClass("d-none");
				}

				if (data.basket_count > basketCount) {
					Messages.success("Product successfully added to your basket");
				}

				self.setBasketCount(data.basket_count);
				self.clearButtonLoading();
			},
			error: function () {
				self.clearButtonLoading();
			},
		});
	}

	addToBasket($form) {
		const self = this;

		if (self.checkAllAttributesSelected($form)) {
			let formData = {},
				backOrderPopup = false;

			$.each($form.serializeArray(), function (key, field) {
				if (field.name.indexOf("team[") === -1) {
					formData[field.name] = field.value;
				}
			});

			if (window.site.backorderStockcodes.indexOf(parseInt(formData.stockcode_id)) !== -1) {
				backOrderPopup = true;
			}

			if (backOrderPopup && formData.ignore_popup != 1) {
				self.openBackOrderPopup(formData);
			} else {
				oc.progressBar.show();

				// add to basket
				oc.ajax("shopBasket::onAddBasketItem", {
					data: formData,
					success: function (data, responseCode, xhr) {
						this.success(data, responseCode, xhr);

						oc.progressBar.hide();

						if (data.response == "success") {
							//Messages.success("Product successfully added to your basket");

							$.magnificPopup.instance.close();

							self.trackAddToBasket();

							self.setBasketCount(data.basket_count);
						} else {
							Messages.error("Sorry we don&apos;t have any more stock of this item");
						}
					},
				});
			}
		}
	}

	addBundleToBasket($form, $button) {
		const self = this;
		const bundleId = $form.find("input[name='bundle_id']").val();

		self.activeButton = $button;
		$button.addClass("is-loading").prop("disabled", true);

		oc.request($form[0], "shopBasket::onAddBundleBasketItem", {
			files: true,
			success: function (data, responseCode, xhr) {
				if (data && data.response === "success") {
					self.onUpdateBasketCount(bundleId);
					return;
				}

				if (data && data.error_message) {
					Messages.error(data.error_message);
				} else if (data && data.message) {
					Messages.error(data.message);
				} else {
					Messages.error("Sorry, the bundle could not be added.");
				}

				self.clearButtonLoading();
			},
			error: function (data, responseCode, xhr) {
				if (data && data.message) {
					Messages.error(data.message);
				} else if (data && data.error_message) {
					Messages.error(data.error_message);
				} else {
					Messages.error("Sorry, the bundle could not be added.");
				}

				self.clearButtonLoading();
			}
		});
	}

	addToBasketMulti($form, $button) {
		const self = this;
		if (self.checkAllAttributesSelected($form, true)) {
			let formData = {},
				backOrderPopup = false;

			$.each($form.serializeArray(), function (key, field) {
				formData[field.name] = field.value;
			});

			$.each(formData, function (key, val) {
				if (key.indexOf("team[") !== -1 && key.indexOf("[stockcode_id]") !== -1) {
					if (window.site.backorderStockcodes.indexOf(parseInt(val)) !== -1) {
						backOrderPopup = true;
					}
				}
			});

			if (backOrderPopup && formData.ignore_popup != 1) {
				self.openBackOrderPopup(formData);
			} else {
				oc.progressBar.show();

				// Show loading state on the button (background image replaces text)
				if ($button && $button.length) {
					self.activeButton = $button;
					$button.addClass("is-loading");

					// If the request fails before the success message, clear the loading state
					$form.one("ajaxFail", function () {
						self.clearButtonLoading();
					});
				}

				// submit form
				console.log('submitting');
				oc.request($form[0]);
				console.log($form)
				//self.onUpdateBasketCount();

				oc.progressBar.hide();

				//self.removeItem(0);

				//self.addItemsToBackOrder($form.serializeArray());
				console.log('submitted');
			}
		}
	}





	addWishlistToBasket($form) {
		const self = this;

		let formData = $form.serializeJSON();

		oc.progressBar.show();

		// add to basket
		oc.ajax("shopBasket::onAddMultipleBasketItems", {
			data: formData,
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				if (data.response == "success") {
					self.onUpdateBasketCount();
				} else {
					Messages.error("Sorry we don&apos;t have enough stock of one of these items");
				}
			},
		});
	}

	checkAllAttributesSelected($form, team = false) {
		const self = this;

		// Determine the required fields based on the team flag
		const $requiredFields = team
			? $form.find(
				".js-basket-required-team-field, .js-basket-required-team-personalisation-field, .js-basket-required-field"
			)
			: $form.find(".js-basket-required-field, .js-basket-required-personalisation-field");

		// Remove is-erroneous class by default
		$requiredFields.removeClass("is-erroneous");
		$(".js-personalise-link").removeClass("is-erroneous");

		let allRequiredCompleted = true;
		let notSelectedField = "";
		let errorCount = 0;

		// Check required fields for empty values
		$requiredFields.each(function () {
			let $field = $(this);

			let isPersonalisationField =
				$field.hasClass("js-basket-required-team-personalisation-field") ||
				$field.hasClass("js-basket-required-personalisation-field");

			// Back orders do not require personalisation details
			if (isPersonalisationField && window.site.backorderStockcodes && window.site.backorderStockcodes.length) {
				let relatedStockcodeId = null;
				let $row = $field.closest(".js-product-team-quantity-row");

				if ($row.length) {
					relatedStockcodeId = $row.find(".js-product-team-quantity-size").val();
				} else {
					relatedStockcodeId = $form.find("input[name='stockcode_id']").val();
				}

				if (relatedStockcodeId && window.site.backorderStockcodes.indexOf(parseInt(relatedStockcodeId, 10)) !== -1) {
					return;
				}
			}

			if (!$field.val()) {
				$field.addClass("is-erroneous");
				$field.next(".select2-container").addClass("is-erroneous");

				// If it's a personalisation field, add the error class to the personalise link
				if (isPersonalisationField) {
					$(".js-personalise-link").addClass("is-erroneous");
				}

				// Set notSelectedField to the first erroneous field
				if (!notSelectedField) {
					notSelectedField = $field.data("field-type");
				}

				allRequiredCompleted = false;

				errorCount++;
			}
		});

		// Display error messages if not all required fields are completed
		if (!allRequiredCompleted) {
			if (errorCount > 1) {
				Messages.error("Please select valid options");
			} else {
				Messages.error(
					`Please select a ${notSelectedField ? notSelectedField.toLowerCase() : "option"
					}`
				);
			}
			return false;
		}

		// If this is a bundle form, ensure none of the selected bundle items are out of stock.
		// Bundle selects/inputs include stockcode data on the selected option: data-out-of-stock-message
		if ($form.hasClass('js-add-bundle-to-basket') || $form.find('.js-bundle-stockcodes').length > 0) {
			let outOfStockFound = false;
			$form.find('select').each(function () {
				const $sel = $(this);
				const $opt = $sel.find('option:selected');
				const oos = $opt.data('out-of-stock-message');
				if (oos && oos !== 'preorder_in_bundle' && oos !== 'preorder') {
					outOfStockFound = true;
					return false; // break
				}
			});

			if (outOfStockFound) {
				Messages.error("Sorry we don't have enough stock of one of these items");
				return false;
			}
		}

		return true;
	}

	removeItem(itemId) {
		const self = this;

		oc.progressBar.show();

		// removes item from basket
		oc.ajax("shopBasket::onRemoveBasketItem", {
			data: {
				item_id: itemId,
			},
			update: {
				"shopBasket/default": ".js-basket",
				"shopBasket/edit": ".js-basket-edit",
				"banner/delivery-banner": ".js-delivery-banner",
			},
			success: function (data, responseCode, xhr) {

				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				self.setBasketCount(data.basket_count);
				let text = $(".add-to-basket-product-id").text();
				self.onUpdateBasketCount(text );
			},
		});
	}

	removeBundleItem(instanceId) {
		const self = this;

		oc.progressBar.show();

		// removes item from basket
		oc.ajax("shopBasket::onRemoveBasketBundleItem", {
			data: {
				instance_id: instanceId,
			},
			update: {
				"shopBasket/default": ".js-basket",
				"shopBasket/edit": ".js-basket-edit",
				"banner/delivery-banner": ".js-delivery-banner",
			},
			success: function (data, responseCode, xhr) {

				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				self.setBasketCount(data.basket_count);
			},
		});
	}

	setBasketCount(count) {
		const self = this;

		count = parseInt(count);

		if (count > 0) {
			$(".js-basket-count").attr("data-count", count);
		} else {
			$(".js-basket-count").removeAttr("data-count");
		}
	}

	toastSuccess(isSuccess) {
		const self = this;
		if (isSuccess) {
			Messages.success("Product successfully added to your basket");
		} else {
			Messages.error("Sorry an error occcurred adding this product to your basket");
		}
		self.clearButtonLoading();
	}

	updateItemQuantity($form) {
		const self = this;

		var $basketWrapper = $(".js-basket"),
			$basketCount = $(".js-basket-count"),
			$basketResponse = $(".js-add-to-basket-response");

		var formData = {};
		$.each($form.serializeArray(), function (key, field) {
			formData[field.name] = field.value;
		});

		//Messages.remove();

		oc.progressBar.show();

		// removes item from basket
		oc.ajax("shopBasket::onUpdateBasketItemQuantity", {
			data: formData,
			update: {
				"shopBasket/default": ".js-basket",
				"shopBasket/edit": ".js-basket-edit",
				"banner/delivery-banner": ".js-delivery-banner",
			},
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);
				oc.progressBar.hide();

				if (data.response == "success") {
					self.setBasketCount(data.basket_count);

					Messages.success("Quantity successfully updated");
				} else {
					Messages.error("Sorry we don&apos;t have any more stock of this item");
				}
			},
		});
	}

	openBackOrderPopup(formData) {
		const self = this,
			popupsInstance = new Popups();

		oc.progressBar.show();

		oc.ajax("shopBasket::onLoadBackOrderData", {
			update: {
				"shopProduct/items-out-of-stock/content": ".js-popup-items-out-of-stock",
			},
			data: formData,
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				popupsInstance.openInlineCentralPopup("#popup-items-out-of-stock");
			},
		});
	}

	// mergeBackOrderQuantities() {
	// 	const self = this;

	// 	let inputValues = {};

	// 	// Iterate over each input with the specified name
	// 	$('input[name^="back_order_stockcodes"]').each(function () {
	// 		let inputName = $(this).attr("name");
	// 		let inputValue = $(this).val();

	// 		// Check if the name already exists in the object
	// 		if (inputValues.hasOwnProperty(inputName)) {
	// 			// Add the value of the current input to the existing value
	// 			inputValues[inputName] += parseInt(inputValue);
	// 		} else {
	// 			// If the name doesn't exist, set the value in the object
	// 			inputValues[inputName] = parseInt(inputValue);
	// 		}

	// 		// Remove the current input
	// 		$(this).remove();
	// 	});

	// 	console.log(inputValues);

	// 	// Create new inputs with updated values
	// 	$.each(inputValues, function (name, value) {
	// 		let newInput = $('<input type="hidden">').attr({
	// 			name: name,
	// 			value: value,
	// 		});

	// 		$(".js-add-items-to-backorder").append(newInput);
	// 	});

	// 	return self;
	// }

	setBackOrderRefInput() {
		const self = this;

		// Get display Val
		const displayVal = $(".js-backorder-reference-display-input").val();

		// Set display val of hidden input
		$(".js-backorder-reference-input").val(displayVal);

		return self;
	}

	addItemsToBackOrder(formData) {
		const self = this,
			popupsInstance = new Popups();

		var formDataFormatted = {};
		$.each(formData, function (key, field) {
			formDataFormatted[field.name] = field.value;
		});

		oc.progressBar.show();

		oc.ajax("shopBasket::onSaveBackOrderStockcodes", {
			data: formDataFormatted,
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				if (data.backorder) {
					Messages.success("Items added to back order");
				}

				if (data.user) {
					$.magnificPopup.instance.close();
				} else {
					popupsInstance.openAjaxPopup(
						"/account/sign-in?redirect=" + window.location.pathname
					);
				}
			},
		});
	}

	trackAddToBasket(item) {
		const self = this;

		gtag("event", "add_to_cart", {
			items: [window.site.productTrackingInfo],
		});
	}
}
